import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import Isvg from 'react-inlinesvg';

import {
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Nav,
  NavItem,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';

class HomeHeader extends Component {
  constructor(props) {
    super(props);
    this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);

    this.state = {};

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    if (this.props.socketIOClient) {
      this.registerSocketIOEvents();
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps) {
    if (this.props.socketIOClient) {
      this.registerSocketIOEvents();
    }
  }

  registerSocketIOEvents() {
    if (this.state._registeredEvents) return;

    this.setState({
      _registeredEvents: true,
    });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);

    if (!this.props.socketIOClient) return;
  }

  logout = () => {};

  render() {
    return <div></div>;
  }
}

export default HomeHeader;
